import React, { useMemo, useState } from 'react'
import { css } from '@emotion/core'
import { InputField } from '@/components/molecules/input-field'
import { RequireText } from '@/components/atoms/require-text'
import { useTranslation } from 'react-i18next'
import { useSelfCheckInState } from '@/hooks/use-self-check-in-state'
import { createSelfCheckinResponsiveStyle, FrontTabletResponsiveToken } from '@/utils/front-tablet-responsive-style'

type Props = {
  onValidate: (isValid: boolean) => void
}

export const ConfirmationWhoForm: React.FC<Props> = props => {
  const { t } = useTranslation()
  const { state } = useSelfCheckInState()
  const [value, setValue] = useState<string>()

  const validMessage = useMemo(() => {
    if (value === undefined) {
      props.onValidate(false)
      return ''
    }
    if (!value) {
      props.onValidate(false)
      return t('Required field has not been entered')
    }
    const hotelCode = state.setting.basicInfo.telephone.replaceAll('-', '').slice(-4)
    if (value !== hotelCode) {
      props.onValidate(false)
      if (value.length === 4) {
        return t('Incorrect facility code. Please check the code.')
      } else {
        return ''
      }
    }
    props.onValidate(true)
    return ''
  }, [value])

  return (
    <div css={componentStyle}>
      <h2 className="title">
        ビデオ通話での本人確認 <RequireText />
      </h2>
      <div className="description">
        <p>
          {t(
            'By ordinance, you must identify yourself via video call when you check in. Please click on “🎧” in the lower right corner of the screen to initiate a video call with our staff.',
          )}
        </p>
        <p>{t('After the call, please enter the “Facility Code (4 digits)” provided by the staff.')}</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
        <InputField
          customStyle={{
            input: {
              fontSize: 21,
              height: 61.21,
              borderRadius: 40,
              lineHeight: '31px',
              padding: '14px 35px',
              color: '#272727',
            },
          }}
          customErrorStyle={{
            fontSize: 14,
            fontWeight: 'bold',
            marginTop: 16,
            color: 'rgb(255, 39, 0)',
          }}
          type="tel"
          placeholder="1234"
          value={value}
          onChange={e => setValue(e.target.value)}
          error={validMessage}
        />
      </div>
    </div>
  )
}

const componentStyle = css(
  {
    '*': { fontFamily: 'Noto Sans JP' },
    '.title': {
      marginBottom: 16,
      fontSize: 18,
      fontWeight: 'bold',
    },
    '.description': {
      marginBottom: 32,
      lineHeight: 1.5,
    },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: {
      '.title': { fontSize: FrontTabletResponsiveToken.headingFontSize.landscape13 },
      '.description': { fontSize: FrontTabletResponsiveToken.bodyFontSize.landscape13 },
    },
  }),
)
